// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"8a76e20e","977":"c4b2be53"}[chunkId] + ".chunk.js";
};